module.exports = __webpack_public_path__ + "a6f1d5d98c9b6caad9caa724f206d769.woff2";